/**
 * Common props to centralise a div
 */
export const ViewFullCenterFlexProps = {
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  width: '100%',
  height: '100%'
};
